import { render, staticRenderFns } from "./profile-family-form.vue?vue&type=template&id=62204c7c&scoped=true&"
import script from "./profile-family-form.ts?vue&type=script&lang=ts&"
export * from "./profile-family-form.ts?vue&type=script&lang=ts&"
import style0 from "./profile-family-form.scss?vue&type=style&index=0&id=62204c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62204c7c",
  null
  
)

export default component.exports